import React, {Component} from "react";
import {Card, Layout, Progress} from "antd";
import UserRegistration from "./UserRegistration";
import CompanySearch from "../Boilerplate/CompanySearch";
import CompanyPending from "./CompanyPending";
import {connect} from "react-redux";
import {stopAuthPoll} from "../../actions/ui";
import {setViewPath} from "../../actions/view";
import {BreadcrumbProvider} from "../Boilerplate/BreadcrumbContext";
import {Helmet} from "react-helmet";
import {RegistrationHeader} from "../Boilerplate/Menus";

export class _Registration extends Component {
  componentDidMount() {
    const { onMount } = this.props;
    onMount && onMount();
  }

  render() {
    const { state, onStateChange, onCreate, onJoin } = this.props;
    const step = state === 'beginUserRegistration' ? 0 : state === 'registrationInProgress' ? 1 : 2;
    return <BreadcrumbProvider>
      <div>
        <Helmet>
          <title>cProject</title>
        </Helmet>
        <Layout>
          <RegistrationHeader authState={state}/>
          <div id={'cproject-layout'} className={'layout-registration ant-layout'} style={{marginTop: 137}}>
            <div id={'content'} className={'ant-layout-content'}>
              <Card title={<h1 id='registration-header'>Registration</h1>}>
                <div id='registration-progress'>
                  {step + 1}/3
                  <Progress
                    strokeColor='#2d9905'
                    status='active'
                    percent={100 * ((step + 1)/3)}
                    showInfo={false}
                  />
                </div>
                {state === 'beginUserRegistration' ?
                  <UserRegistration
                    onStateChange={onStateChange}
                    {...this.props}
                  /> : state === 'registrationInProgress' ?
                    <CompanySearch
                      onCreate={onCreate}
                      onJoin={onJoin}
                    /> : state === 'pendingCompanyAccept' ?
                      <CompanyPending/> : 'Unknown state'
                }
              </Card>
            </div>
          </div>
        </Layout>
      </div>
    </BreadcrumbProvider>;
  }
}

export const Registration = connect(
  null,
  (dispatch, props) => ({
    onMount: () => {
      dispatch(setViewPath(['registration']));
      dispatch(stopAuthPoll());
    }
  })
)(_Registration);



// WEBPACK FOOTER //
// ./src/components/Security/Registration.js